import * as types from '../actionTypes/PaymentMethodsActionTypes';

function PaymentMethodsReducer(state = {}, action = {}) {
    // NOSONAR
    switch (action.type) {
        case types.GET_PAYMENT_METHODS:
        case types.ADD_PAYMENT_METHOD:
        case types.UPDATE_PAYMENT_METHOD:
        case types.SET_DEFAULT_PAYMENT_METHOD:
        case types.DELETE_PAYMENT_METHOD: {
            const isLoading = true;
            const isSuccess = false;
            const requestFrom = null;
            return { ...state, isLoading, isSuccess, requestFrom, error: {} };
        }
        case types.GET_PAYMENT_METHODS_SUCCESS: {
            const { isLoading, paymentMethods, defaultPaymentMethod, isSuccess } = action.payload;
            return { isLoading, paymentMethods, isSuccess, defaultPaymentMethod };
        }
        case types.GET_PAYMENT_METHODS_ERROR: {
            const { isLoading, isSuccess, error } = action.payload;
            return { ...state, isLoading, isSuccess, error };
        }
        case types.ADD_PAYMENT_METHOD_SUCCESS: {
            const { isLoading, response, isSuccess, requestFrom } = action.payload;
            const newState = { ...state, isSuccess, isLoading, requestFrom };
            if (response.expressCheckout) {
                newState.paymentMethods = newState.paymentMethods.map((payment) => {
                    if (payment.expressCheckout) {
                        return { ...payment, expressCheckout: false, isDefault: false };
                    }
                    return payment;
                });
            }
            newState.paymentMethods.push(response);
            if (response.isDefault) {
                newState.defaultPaymentMethod = response;
            }
            return newState;
        }
        case types.ADD_PAYMENT_METHOD_ERROR:
        case types.UPDATE_PAYMENT_METHOD_ERROR:
        case types.DELETE_PAYMENT_METHOD_ERROR: {
            const { isLoading, isSuccess, error, requestFrom } = action.payload;
            return { ...state, isSuccess, isLoading, error, requestFrom };
        }
        case types.UPDATE_PAYMENT_METHOD_SUCCESS: {
            const { isLoading, response, isSuccess, requestFrom } = action.payload;
            const newState = { ...state, isSuccess, isLoading, requestFrom };
            if (response.isDefault) {
                newState.defaultPaymentMethod = response;
            }
            newState.paymentMethods = newState.paymentMethods.map((payment) => {
                if (payment.id === response.id) {
                    if (requestFrom === 'PATCH_FOR_DEFAULT_CARD') {
                        newState.defaultPaymentMethod = {
                            ...payment,
                            expressCheckout: true,
                            isDefault: true,
                        };
                        return newState.defaultPaymentMethod;
                    }
                    return response;
                }
                if (response.expressCheckout && payment.expressCheckout) {
                    return { ...payment, expressCheckout: false, isDefault: false };
                }
                return payment;
            });
            return newState;
        }
        case types.DELETE_PAYMENT_METHOD_SUCCESS: {
            const { isLoading, paymentId, isSuccess, requestFrom } = action.payload;
            const newState = { ...state, isSuccess, isLoading, requestFrom };
            newState.paymentMethods = newState.paymentMethods.filter((payment) => {
                if (payment.id === paymentId) {
                    return false;
                }
                return true;
            });
            return newState;
        }
        case types.CLEAN_REQUEST_PAYMENT_METHOD: {
            const requestFrom = null;
            return { ...state, requestFrom };
        }
        case types.HIDE_PAYMENT: {
            const showPayment = false;
            return { ...state, showPayment };
        }
        default:
            return state;
    }
}

PaymentMethodsReducer.reducerName = 'paymentDetails';
export default PaymentMethodsReducer;
